export default function (formatMessage: Function) {
  return {
    reasonOptions: [
      {
        value: "createdByError",
        label: formatMessage({
          id: "terminate_reason_incomplete_created_by_error",
          defaultMessage: "Creato per errore",
        }),
      },
      {
        value: "notRealized",
        label: formatMessage({
          id: "terminate_reason_incomplete_not_realized",
          defaultMessage: "Non più realizzato",
        }),
      },
    ],
  };
}
